<template>
  <div class="MedicenCata">
    <div class="main">
      <div class="main-right" ref="mainRight">
        <!-- 顶部工具栏 -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <!-- 表格 -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleDbShowData" show-summary
                    :summary-method="getSummaries">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148"
                             v-if="$store.getters.hasPermission('system:clinicFeeManagement:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClinicFeeChargeAgainst(scope.row)" size="mini"
                             :disabled="scope.row.nuyState !== 0">冲销
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :title='addClinicFeeManagementForm.id == null ? "新增其他收入单" : (showClinicFeeManagementDialogVisible ? "查看其他收入单" : "修改其他收入单")'
            :visible.sync="addClinicFeeManagementDialogVisible"
            :close-on-click-modal="false"
            width="700px"
            @close="handleCloseClinicFeeManagement"
            class="custom-form-dialog">
          <el-form size="mini" :model="addClinicFeeManagementForm" ref="addClinicFeeManagementForm"
                   :rules="addClinicFeeManagementFormRules" label-width="110px" label-position="right"
                   :disabled="showClinicFeeManagementDialogVisible">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="收入名称:" prop="name">
                  <el-input v-model="addClinicFeeManagementForm.name" placeholder="请输入完整名称" clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="资金账户:" prop="capitalAccount">
                  <el-cascader
                      v-model="addClinicFeeManagementForm.capitalAccount"
                      :options="capitalAccountTree"
                      :props="cascaderProps"
                      placeholder="请选择资金账户"
                      filterable
                      clearable
                      style="width: 100%">
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经手人:" prop="rebPersion">
                  <el-select v-model="addClinicFeeManagementForm.rebPersion">
                    <el-option v-for="item in staffListOptions" :key="item.id" :label="item.label"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他收入:" prop="expendType">
                  <el-cascader
                      v-model="addClinicFeeManagementForm.expendType"
                      :options="incomeCategoryTree"
                      :props="cascaderProps"
                      placeholder="请选择其他收入"
                      filterable
                      clearable
                      style="width: 100%">
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="金额:" prop="amount">
                  <el-input-number v-model="addClinicFeeManagementForm.amount" :min="0"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发生时间:" prop="busTime">
                  <el-date-picker v-model="addClinicFeeManagementForm.busTime" type="date" placeholder="选择日期"
                                  value-format="yyyy-MM-dd"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门:" prop="deptId">
                  <el-select v-model="addClinicFeeManagementForm.deptId">
                    <el-option
                        v-for="item in deptOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="备注:">
              <el-input type="textarea" v-model="addClinicFeeManagementForm.remarks" :rows="3"
                        placeholder="可输入额外说明信息" resize="none" show-word-limit maxlength="200"/>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showClinicFeeManagementDialogVisible" size="mini" type="primary"
                       @click="handleAddFinancialSummaryAccount">保存
            </el-button>
            <el-button :disabled="showClinicFeeManagementDialogVisible" size="mini"
                       @click="handleCloseClinicFeeManagement">取消
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background>
    </el-pagination>
  </div>
</template>

<script>
import {pinyin} from "pinyin-pro";
import {getContuntList, getDeptList} from "@/api/reservation/reservation";
import {getDoctorList} from "@/api/scheduling/scheduling";
import {getOnCredit} from "@/api/reservation/onCredit";
import dayjs from "dayjs";
import {withLoading} from "@/untils/loading";
import {getExpenseCategoryList} from "@/api/managementMenu/expenseCategory";
import {
  addClinicFeeManagement,
  editClinicFeeManagement, getClinicFeeChargeAgainst,
  getClinicFeeManagementById,
  getClinicFeeManagementPage
} from "@/api/clinicFeeManagement/clinicFeeManagement";
import {
  getFinancialSummaryAccountList,
  getOneFinancialSummaryAccountById
} from "@/api/financialSummaryManagement/financialSummaryAccount";
import {selectDropDownList} from "@/api/PSI";
import {getFinanceclassList} from "@/api/clasificacionContable/clasificacionContable";

export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      defaultProps: {children: 'children', label: 'label'},
      windowWidth: '',
      searchValue: '',
      CatalogueName: '其他收入',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',
      queryConditionForm: {name: ''},
      loading: false,
      addClinicFeeManagementDialogVisible: false,
      showClinicFeeManagementDialogVisible: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      applyobjectOptions: [{id: 0, label: '全部'}, {id: 1, label: '门诊'}, {id: 2, label: '住院'}],
      stateOption: [{id: 0, label: '禁用'}, {id: 1, label: '可用'}],
      doctorOptions: [],
      addClinicFeeManagementFormRules: {
        amount: [{required: true, message: ' ', trigger: 'change'}],
        capitalAccount: [{required: true, message: ' ', trigger: 'change'}],
        name: [{required: true, message: ' ', trigger: 'blur'}],
        expendType: [{required: true, message: ' ', trigger: 'change'}],
        busTime: [{required: true, message: ' ', trigger: 'blur'}],
        rebPersion: [{required: true, message: ' ', trigger: 'blur'}],
      },
      addClinicFeeManagementForm: {
        id: null,
        amount: null,
        costTypeId: null,
        name: "",
        remarks: "",
        sosTypeId: null,
        supplierId: null,
        type: 2,
        busTime: '',
        rebPersion: null,
        expendType: null,
        deptId: JSON.parse(localStorage.getItem('userInfo'))?.selDept,
      },
      tableData: [],
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning", auth: 'system:clinicFeeManagement:add'},
      ],
      elTree: [{label: '全部', path: '', title: '', icon: 'el-icon-news', children: []}],
      tableRows: [
        {name: "名称", prop: "name", type: ""},
        {name: "资金账户", prop: "capitalAccountName"},
        {name: "其他收入", prop: "expendTypesName"},
        {name: "金额", prop: "amount", type: ""},
        {name: "冲销金额", prop: "nuyAmt", type: ""},
        {name: "冲销状态", prop: "nuyState", type: "", op: 'nuyOption'},
        {name: "冲销人", prop: "nuyUserName", type: ""},
        {name: "冲销时间", prop: "nuyTime", type: ""},
        {name: "创建人", prop: "createName", type: ""},
        {name: "创建时间", prop: "createTime", type: ""},
        {name: "备注", prop: "remarks", type: ""},
      ],
      areaOption: [{id: 1, label: '省内'}, {id: 2, label: '省外'}, {id: 3, label: '进口'}],
      nuyOption: [{id: 0, label: '否'}, {id: 1, label: '冲销原单'}, {id: 2, label: '冲销负单'}],
      expenseCategoryOptions: [],
      allExpenseCategoryOptions: [],
      financialOptions: [],
      supplierOptions: [],
      staffListOptions: [],
      balanceTypeOptions: [{id: 1, label: '支出'}],
      // 级联选择器配置：直接返回叶子节点ID
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false,
        emitPath: false
      },
      capitalAccountTree: [],   // 资金账户树
      incomeCategoryTree: [],   // 其他收入树
      rawFinanceList: [],       // 原始财务分类数据（已字符串化 id/parentId）
      deptOptions: [],

      // 财务分类 type 常量（接口文档：1收入 2支出 3资金账户 4资产 5负债）
      FINANCE_TYPE: {
        INCOME: 1,
        EXPEND: 2,
        CAPITAL: 3,
        ASSET: 4,
        LIABILITY: 5
      },

      // 本页面（其他收入）需要展示的收入根节点名称列表
      incomeRootNames: ['其他收入'],
    };
  },
  async mounted() {
    await this.loadFinanceClassData();
    await this.loadData();
    this.allExpenseCategoryOptions = this.$store.getters['preload/getCostTypeOptions'] || [];
    this.supplierOptions = this.$store.getters['preload/getSupplierListOption'] || [];
    this.staffListOptions = this.$store.getters['preload/getStaffListOptions'] || [];
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
    await this.getSupplierOptions();
  },
  methods: {
    async getSupplierOptions() {
      const res = await selectDropDownList();
      this.supplierOptions = res.data.content.map(item => ({id: item.id, label: item.supplierName}));
    },

    /**
     * 加载财务分类：统一 id/parentId 为字符串，status 转数字
     */
    async loadFinanceClassData() {
      try {
        const res = await getFinanceclassList();
        this.rawFinanceList = res.map(item => ({
          ...item,
          id: String(item.id),
          parentId: item.parentId != null ? String(item.parentId) : '0',
          status: item.status != null ? Number(item.status) : 1
        }));
        this.buildCascadeTrees();
      } catch (error) {
        console.error('加载财务分类失败:', error);
        this.$message.error('加载财务分类失败');
      }
    },

    /**
     * 【核心新增】过滤禁用节点及其所有子孙
     * 禁用即整枝隐藏，避免禁用父级后子级变孤立根节点
     */
    filterEnabledWithDescendants(list) {
      const childMap = new Map();
      list.forEach(item => {
        const pid = item.parentId || '0';
        if (!childMap.has(pid)) childMap.set(pid, []);
        childMap.get(pid).push(item);
      });

      const disabledIds = new Set();
      const traverse = (node, parentDisabled = false) => {
        const isDisabled = parentDisabled || Number(node.status) === 0;
        if (isDisabled) {
          disabledIds.add(node.id);
        }
        const children = childMap.get(node.id) || [];
        children.forEach(child => traverse(child, isDisabled));
      };

      const roots = list.filter(item => !item.parentId || item.parentId === '0');
      roots.forEach(root => traverse(root));

      return list.filter(item => !disabledIds.has(item.id));
    },

    /**
     * 按 type 动态构建树
     * - 只保留 type 匹配的节点
     * - 根节点 = parentId 不在当前 type 节点集合内（或 parentId 为 '0'）
     * - 清理空的 children
     * - 过滤掉没有子节点的根
     */
    buildTreeByType(type) {
      const list = this.rawFinanceList.filter(item => item.type === type);
      if (list.length === 0) return [];

      const nodeMap = new Map();
      list.forEach(item => {
        nodeMap.set(item.id, {
          id: item.id,
          name: item.name,
          label: item.name,
          parentId: item.parentId,
          type: item.type,
          children: []
        });
      });

      // 只连同一 type 内的父子关系
      list.forEach(item => {
        const node = nodeMap.get(item.id);
        if (item.parentId && nodeMap.has(item.parentId)) {
          nodeMap.get(item.parentId).children.push(node);
        }
      });

      // 根节点：parentId 不在当前 type 集合内
      const roots = [];
      nodeMap.forEach(node => {
        if (!node.parentId || !nodeMap.has(node.parentId)) {
          roots.push(node);
        }
      });

      // 清理空 children
      const cleanTree = (node) => {
        if (node.children.length === 0) {
          delete node.children;
        } else {
          node.children.forEach(cleanTree);
        }
      };
      roots.forEach(cleanTree);

      // 过滤掉没有子节点的根节点
      return roots.filter(root => root.children && root.children.length > 0);
    },

    /**
     * 构建资金账户树 + 其他收入树
     * - 资金账户：type = 3，完全动态
     * - 其他收入：type = 1 按 incomeRootNames 名称筛选根节点
     * - 两者都先过滤禁用节点及其子孙
     */
    buildCascadeTrees() {
      // 【关键】先过滤禁用节点及其所有子孙
      const enabledList = this.filterEnabledWithDescendants(this.rawFinanceList);

      // 临时替换 rawFinanceList 后复用 buildTreeByType
      const originalRaw = this.rawFinanceList;
      this.rawFinanceList = enabledList;

      try {
        // 资金账户：type = 3
        this.capitalAccountTree = this.buildTreeByType(this.FINANCE_TYPE.CAPITAL);
        console.log('资金账户树（已过滤禁用）:', this.capitalAccountTree);

        // 其他收入：type = 1，按根节点名称筛选
        const allIncomeTree = this.buildTreeByType(this.FINANCE_TYPE.INCOME);
        if (Array.isArray(this.incomeRootNames) && this.incomeRootNames.length > 0) {
          const matched = allIncomeTree.filter(root => this.incomeRootNames.includes(root.name));
          this.incomeCategoryTree = matched.length > 0 ? matched : allIncomeTree;
        } else {
          this.incomeCategoryTree = allIncomeTree;
        }
        console.log('其他收入树（已过滤禁用）:', this.incomeCategoryTree);
      } finally {
        this.rawFinanceList = originalRaw;
      }
    },

    // 表格合计
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'amount' || column.property === 'nuyAmt') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(v => isNaN(v))) {
            sums[index] = values.reduce((prev, curr) => prev + (isNaN(curr) ? 0 : curr), 0);
            sums[index] = '¥ ' + sums[index].toFixed(2);
          } else {
            sums[index] = 'N/A';
          }
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 提交表单
    async handleAddFinancialSummaryAccount() {
      try {
        await this.$refs.addClinicFeeManagementForm.validate();
      } catch (error) {
        this.$message.warning("请完善表单信息");
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        const submitData = {...this.addClinicFeeManagementForm};
        let res;
        if (!submitData.id) {
          res = await addClinicFeeManagement(submitData);
        } else {
          res = await editClinicFeeManagement(submitData);
        }
        if (res.code === 200) {
          this.handleCloseClinicFeeManagement();
          await this.loadData();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    handleCloseClinicFeeManagement() {
      this.addClinicFeeManagementForm = Object.assign({}, this.$options.data.call(this).addClinicFeeManagementForm);
      this.$nextTick(() => {
        this.$refs.addClinicFeeManagementForm?.clearValidate();
      });
      this.addClinicFeeManagementDialogVisible = false;
      this.showClinicFeeManagementDialogVisible = false;
    },

    // 双击查看：回显时把 capitalAccount / expendType 统一转字符串
    async handleDbShowData(row) {
      const res = await getClinicFeeManagementById(row.id);
      if (res.code === 200) {
        const data = {...res.data};
        data.capitalAccount = data.capitalAccount != null ? String(data.capitalAccount) : null;
        data.expendType = data.expendType != null ? String(data.expendType) : null;
        this.addClinicFeeManagementForm = data;
        this.addClinicFeeManagementDialogVisible = true;
        this.showClinicFeeManagementDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },

    // 冲销
    async handleClinicFeeChargeAgainst(row) {
      try {
        await this.$confirm(`确认冲销【${row.name}】吗？`, '冲销确认', {
          confirmButtonText: '确认冲销',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        });
        const res = await getClinicFeeChargeAgainst({id: row.id});
        if (res.code === 200) {
          this.$message.success(res.message);
          await this.loadData();
        } else {
          this.$message.error(res.message || "系统异常:请联系管理员");
        }
      } catch (error) {
        if (error !== 'cancel') this.$message.info('已取消冲销操作');
      }
    },

    // 加载表格数据
    async loadData() {
      try {
        const res = await getClinicFeeManagementPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',
          type: 2
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    handClick(i) {
      switch (i) {
        case 0:
          this.loadData();
          break;
        case 1:
          this.addClinicFeeManagementDialogVisible = true;
          break;
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 20;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => this.getTextWidth(String(text || '')) + padding);
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, {column}) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", {class: "table-head", style: {width: "100%"}}, [column.label]);
    },

    // 表格列值映射
    safeGetMappedValue(col, row) {
      const raw = row[col.prop];
      if (raw === null || raw === undefined) return '';
      if (!col.op || !Array.isArray(this[col.op])) return raw;
      const match = this[col.op].find(item => String(item.id) === String(raw));
      return match?.label ?? raw;
    },
  }
}
</script>

<style lang="less" scoped>
/* 样式保持不变，继承原有 */
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    max-height: 70vh !important;
    height: auto !important;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0;

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .aform, .bform {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 5px;
        min-height: 0;

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0;

          .el-tabs__content {
            flex: 1;
            overflow: visible;
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0;

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

.MedicenCata {
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    .header-icon {
      display: flex;
      align-items: center;
    }
  }

  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto;

    .main-left {
      .custom-tree {
        max-height: 100%;
        overflow-y: auto;
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }
      }

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {
      }
    }
  }

  .feet {
    .addmessagesBox {
      .aform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }

      .bform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }
    }

    .messagesBox {
      .tabs {
        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }
    }
  }
}
</style>